export default "__VITE_ASSET__BY48CJP7__"